module.exports = __webpack_public_path__ + "img/profile_settings_black.29404dd4.svg";